// extracted by mini-css-extract-plugin
module.exports = {"list":"styles__list___R_dzs"};